import { AuthContext } from "AuthProvider";
import { useContext } from "react";

/**
 * User display preferences from AuthContext: unit system, number locale, and
 * display currency. Currency is label-only (no conversion or recalculation).
 */
export default function useDisplayPreferences() {
  const { unitSystem, numberLocale, currency } = useContext(AuthContext);
  return {
    system: unitSystem || "metric",
    locale: numberLocale || "en-US",
    currency: currency || "EUR"
  };
}
